import Game from './Game';

import './App.css';

function App() {
  return (
    <div className="App">
      <h1 style={{textAlign: "center"}}><p style={{textDecoration: "line-through", display: "inline"}}>Code Cracker</p> Node Smacker</h1>
      <Game />
    </div>
  );
}

export default App;
